module.exports = __webpack_public_path__ + "static/media/bg1.639d8038.jpg";